/**
 * MotoristaTransbordo
 * @author Simpli CLI generator
 */
import {$, ID, TAG, Resource} from 'simpli-web-sdk'
import MotoristaTransbordoSchema from '@/schema/MotoristaTransbordo.schema'

export default class MotoristaTransbordo extends Resource {
  readonly $name: string = 'MotoristaTransbordo'

  readonly $endpoint: string = '/user/motorista/transbordo{/id}'

  get $schema() {
    return MotoristaTransbordoSchema(this)
  }

  get $id() {
    return this.idMotoristaFk
  }
  set $id(val: ID) {
    this.idMotoristaFk = val
  }

  idMotoristaFk: ID = 0

  podeEntregar: boolean = false

  podeReceber: boolean = false
}
